import { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H3 from 'UIComponents/elements/headings/H3';
import UITourCancelButton from 'ui-shepherd-react/button/UITourCancelButton';
import { useTourTrackingMethod } from 'ui-shepherd-react/contexts/TourTrackingContext';
import { cleanupLinkedTour } from '../../util/linkedTourUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OnboardingTourCloseModal = ({
  onConfirm,
  onReject,
  tourId,
  stepId,
  'data-test-id': dataTestId,
  rootNode
}) => {
  const trackingMethod = useTourTrackingMethod('trackTourViewCloseModal');
  const trackTourViewCloseModal = useMemo(() => trackingMethod || (() => {}), [trackingMethod]);
  useEffect(() => {
    trackTourViewCloseModal(tourId, stepId, 'open tour close modal');
  }, [stepId, tourId, trackTourViewCloseModal]);
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": dataTestId,
    rootNode: rootNode,
    use: "conversational",
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboarding-tours-modal.close.title"
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      className: "p-top-6",
      children: [/*#__PURE__*/_jsx(UITourCancelButton, {
        "data-test-id": "onboarding-tour-close-confirm-button",
        onClick: () => {
          trackTourViewCloseModal(tourId, stepId, 'confirm closing tour');
          onConfirm();
          cleanupLinkedTour();
        },
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboarding-tours-modal.close.confirm"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "onboarding-tour-close-reject-button",
        onClick: () => {
          trackTourViewCloseModal(tourId, stepId, 'reject closing tour');
          onReject();
        },
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboarding-tours-modal.close.reject"
        })
      })]
    })]
  });
};
OnboardingTourCloseModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  stepId: PropTypes.string.isRequired,
  tourId: PropTypes.string.isRequired
};
export default OnboardingTourCloseModal;